import { render, staticRenderFns } from "./WidgetCreateUpdate.vue?vue&type=template&id=4b44c17b"
import script from "./WidgetCreateUpdate.vue?vue&type=script&lang=js"
export * from "./WidgetCreateUpdate.vue?vue&type=script&lang=js"
import style0 from "./WidgetCreateUpdate.vue?vue&type=style&index=0&id=4b44c17b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports